const DEPARTMENT_NAMES = ['QA', 'Embedded', 'Developer'];

export const departmentName = (department: number): string =>
  DEPARTMENT_NAMES[department] ?? `Unknown (${department})`;
